
import { useEffect, useState } from "react";

// react-router-dom components
import { useLocation, NavLink ,useNavigate} from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import Link from "@mui/material/Link";
import Icon from "@mui/material/Icon";

// Soft UI Dashboard React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";

// Soft UI Dashboard React examples
import SidenavCollapse from "examples/Sidenav/SidenavCollapse";
import SidenavCard from "examples/Sidenav/SidenavCard";

// Custom styles for the Sidenav
import SidenavRoot from "examples/Sidenav/SidenavRoot";
import sidenavLogoLabel from "examples/Sidenav/styles/sidenav";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Soft UI Dashboard React context
import { useSoftUIController, setMiniSidenav } from "context";
import { getApiHeader } from 'utlis/commonfunctions';
import axios from "axios";
const API_URL = process.env.REACT_APP_API_URL;
const API_TOKEN  = process.env.REACT_APP_API_TOKEN

function Sidenav({ color, brand, brandName, routes, ...rest }) {
  const navigate=useNavigate()
  const [controller, dispatch] = useSoftUIController();
  const { miniSidenav, transparentSidenav } = controller;
  const location = useLocation();
  const { pathname } = location;
  const collapseName = pathname.split("/").slice(1)[0];
  const [permissions,setPermissions]=useState({})
  const [filteredRoutes, setFilteredRoutes] = useState([]);
  const simOnlyUser =  sessionStorage.getItem('simOnlyUser');

  const closeSidenav = () => setMiniSidenav(dispatch, true);

  const closeSidenavOnChildSelect = (close) => {
    setMiniSidenav(dispatch, window.innerWidth < 1200 ? close : null); 
  };

   const handlePermissions = async () => {
    try {
      const headers = await getApiHeader();
      const response = await axios.get(`${API_URL}get-web-permission-group`, {
        headers: headers
      });
  
      if (response.status === 200) {
        const data = response.data.data;

       
        setPermissions(data)
     
        setPermissions(data)
   
        // return data; // Return the data to store it in state
      } else {
        throw new Error(response.data.message || "Failed to fetch permissions");
      }
    } catch (error) {
      console.log(error);
      const errorMessage = error?.response?.data?.message || "An error occurred";
    }
  };

  const handleNumber = async () => {
    try {
      const header = await getApiHeader();
      const response = await axios.get(`${API_URL}wallet/get-wallet-balance`, { headers: header });
      if (response.status === 200) {
        localStorage.setItem("walletAmount", response?.data?.wallet_balance);
      }
    } catch (error) {
       console.log("error in side nav",error)
    }
  };





useEffect(() => {
  handleNumber();
  handlePermissions();
}, []);

// useEffect(() => {
//   if (permissions.length === 0) return;

//   const filterRoutes = (routes, permissions) => {
//     return routes.filter(route => {
//       // Ensure that all routes (protected or not) must have a matching key in the permissions array
//       if (route.key) {
//         return permissions.includes(route.key);
//       }
//       // Recursively filter any children routes if they exist
//       if (route.children) {
//         route.children = filterRoutes(route.children, permissions);
//       }
//       // Return false to exclude routes without a key or permission match
//       return false;
//     });
//   };

//   const filtered = filterRoutes(routes, permissions);
//   setFilteredRoutes(filtered);
// }, [permissions]);



// useEffect(() => {
  
//   if (Object.keys(permissions).length === 0) return;
  
//   const filterRoutes = (routes, permissions) => {
//     return routes.filter(route => {
//       // Check if the route key exists in permissions
//       if (route.key && permissions[route.key]) {
//         // console.log(`${route.key} exists in permissions`);
  
//         // If the route has children, filter them based on permissions
//         if (route.children) {
//           route.children = route.children.filter(childRoute => {
//             // Convert child key to the correct format for permission checking
//             const formattedKey = childRoute.key.replace(/-/g, "_"); // Replace hyphens with underscores
            
//             // Check if the formattedKey exists in permissions for the route key
//             const hasPermission = permissions[route.key].includes(formattedKey);
//             // console.log(`Checking child key: ${childRoute.key}, Has permission: ${hasPermission}`);
//             return hasPermission; // Keep child if it has permission
//           });
  
//           // console.log(`Filtered children for ${route.key}:`, route.children);
  
//           // Return the route if it has filtered children
//           return route.children.length > 0;
//         }
  
//         // Return the route if it has no children but exists in permissions
//         return true; 
//       }
  
//       // console.log(`${route.key} does not exist in permissions`);
//       return false; // Route not allowed
//     });
//   };
  
//   const filtered = filterRoutes(routes, permissions);
//   setFilteredRoutes(filtered);
// }, [permissions, routes]);


useEffect(() => {
  if (Object.keys(permissions).length === 0) return;

  const filterRoutes = (routes, permissions) => {
    return routes.filter(route => {
      // Check if the route key exists in permissions
      const mainCategory = permissions[route.key];

      if (mainCategory) {
        // If the route has children, filter them based on permissions
        if (route.children) {
          route.children = route.children.filter(childRoute => {
            const formattedKey = childRoute.key.replace(/-/g, "_"); // Format key for permission checking

            // If the mainCategory is an array (like for home_internet)
            if (Array.isArray(mainCategory)) {
              return mainCategory.includes(formattedKey); // Directly check permission for array structure
            }

            // If the mainCategory is an object (like for pid_services)
            if (typeof mainCategory === "object") {
              const nestedPermissions = mainCategory[childRoute.key];
              if (nestedPermissions) {
                // Check for grandchild permissions, if any
                if (childRoute.children) {
                  childRoute.children = childRoute.children.filter(grandChild => {
                    const grandChildKey = grandChild.key.replace(/-/g, "_");
                    return nestedPermissions.includes(grandChildKey);
                  });
                  return childRoute.children.length > 0; // Return childRoute if grandchildren exist
                }
                return true; // If no grandchildren, return childRoute
              }
            }

            return false;
          });

          return route.children.length > 0; // Return route if it has filtered children
        }

        // Return route if it exists in permissions and has no children
        return true;
      }

      return false; // Route not allowed
    });
  };

  const filtered = filterRoutes(routes, permissions);
  setFilteredRoutes(filtered);
}, [permissions, routes]);




  useEffect(() => {
    // A function that sets the mini state of the sidenav.
    function handleMiniSidenav() {
      setMiniSidenav(dispatch, window.innerWidth < 1200);
    }

    /** 
     The event listener that's calling the handleMiniSidenav function when resizing the window.
    */
    window.addEventListener("resize", handleMiniSidenav);

    // Call the handleMiniSidenav function to set the state with the initial value.
    // handleMiniSidenav();

    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleMiniSidenav);
  }, [dispatch, location]);

  // Render all the routes from the routes.js (All the visible items on the Sidenav)
  const renderRoutes = filteredRoutes.map(({ type, name, icon, title, noCollapse, key, route, href,children }) => {
    let returnValue;
    

    if (type === "collapse") {
      returnValue = href ? (
        <Link
          href={href}
          key={key}
          target="_blank"
          rel="noreferrer"
          sx={{ textDecoration: "none" }}
        >
          <SidenavCollapse
            color={color}
            name={name}
            icon={icon}
            active={key === collapseName}
            noCollapse={noCollapse}
          />
        </Link>
      ) : (
        <NavLink to={route} key={key}>
          <SidenavCollapse
            color={color}
            key={key}
            name={name}
            icon={icon}
            active={key === collapseName}
            noCollapse={noCollapse}
            children={children}
            onChildSelect={closeSidenavOnChildSelect}
            bgcolor={0}
          />
        </NavLink>
      );
    } else if (type === "title") {
      returnValue = (
        <SoftTypography
          key={key}
          display="block"
          variant="caption"
          fontWeight="bold"
          textTransform="uppercase"
          opacity={0.6}
          pl={3}
          mt={2}
          mb={1}
          ml={1}
        >
          {title}
        </SoftTypography>
      );
    } else if (type === "divider") {
      returnValue = <Divider key={key} />;
    }
    return returnValue;
    
  });

  return (
    <SidenavRoot {...rest} variant="permanent" ownerState={{ transparentSidenav, miniSidenav }}>
      <SoftBox pt={3} pb={1} px={4} textAlign="center">
        <SoftBox
          display={{ xs: "block", xl: "none" }}
          position="absolute"
          top={0}
          right={0}
          p={1.625}
          onClick={closeSidenav}
          sx={{ cursor: "pointer" }}
        >
          <SoftTypography variant="h6" color="secondary">
            <Icon sx={{ fontWeight: "bold" }}>close</Icon>
          </SoftTypography>
        </SoftBox>
        
        <SoftBox  to="" display="flex" alignItems="center">
          
          {brand && <SoftBox component="img" src={
            miniSidenav
              ? "https://www.telsim.com.au/wp-content/uploads/2024/04/cropped-cropped-favicon-32x32.png"
              : "https://nbn.telsim.com.au/static/media/telsim-logo-rose-white.4bfec85f24a5b4db75d5.png"
          } alt="" width="8rem"   onClick={() => simOnlyUser!=1?   navigate("/dashboard"):""}
/>}
          <SoftBox
            width={!brandName && "100%"}
            sx={(theme) => sidenavLogoLabel(theme, { miniSidenav })}
          >
            {/* <SoftTypography component="h6" variant="button" fontWeight="medium">
              {brandName}
            </SoftTypography> */}
          </SoftBox>
        </SoftBox>

      </SoftBox>
      <Divider />
      <List >{renderRoutes}</List>
      <SoftBox pt={2} my={2} mx={2} mt="auto">
        <SidenavCard />
        {/* <SoftBox mt={2}>
          <SoftButton
            component="a"
            href="https://www.telsim.com.au/contact-us/"
            target="_blank"
            rel="noreferrer"
            variant="gradient"
            color="primary"
            fullWidth
          >
            contact customer Support
          </SoftButton>
        </SoftBox> */}
      </SoftBox>
    </SidenavRoot>
  );
}

// Setting default values for the props of Sidenav
Sidenav.defaultProps = {
  color: "info",
  brand: "",
};

// Typechecking props for the Sidenav
Sidenav.propTypes = {
  color: PropTypes.oneOf(["primary", "secondary", "info", "success", "warning", "error", "dark"]),
  brand: PropTypes.string,
  brandName: PropTypes.string.isRequired,
  routes: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default Sidenav;
